export const analyticsId = {
  CARD_MODIFY_CREDIT_LIMIT_STEP_1_VIEW: 'CARD_MODIFY_CREDIT_LIMIT_STEP_1_VIEW',
  CARD_MODIFY_CREDIT_LIMIT_STEP_2_VIEW: 'CARD_MODIFY_CREDIT_LIMIT_STEP_2_VIEW',
  CARD_MODIFY_CREDIT_LIMIT_STEP_3_VIEW: 'CARD_MODIFY_CREDIT_LIMIT_STEP_3_VIEW',
  CARD_MODIFY_CREDIT_LIMIT_WIZARD_FINISH: 'CARD_MODIFY_CREDIT_LIMIT_WIZARD_SUCCESS',
  CARD_MODIFY_CREDIT_LIMIT_NEXT: 'CARD_MODIFY_CREDIT_LIMIT_NEXT',
  CARD_MODIFY_CREDIT_LIMIT_CANCEL: 'CARD_MODIFY_CREDIT_LIMIT_CANCEL',
  CARD_MODIFY_CREDIT_LIMIT_PREVIOUS: 'CARD_MODIFY_CREDIT_LIMIT_PREVIOUS',
};

const commons = {
  sectionFamily: 'banking',
  sectionCategory: 'products',
  sectionName: 'cards',
  interactionType: 'funnel',
  serviceType: 'productSettings',
  processType: 'modifyCreditLimit',
};

export const catalogue = {
  [analyticsId.CARD_MODIFY_CREDIT_LIMIT_STEP_1_VIEW]: ({ productName }) => ({
    ...commons,
    pageName: 'modifyCreditLimit/step01/setLimit',
    processStep: 'step01',
    processDetail: 'selectPaymentMethod',
    productName,
  }),
  [analyticsId.CARD_MODIFY_CREDIT_LIMIT_STEP_2_VIEW]: ({ productName, amount }) => ({
    ...commons,
    pageName: 'modifyCreditLimit/step02/precontractualInformation',
    processStep: 'step02',
    processDetail: 'precontractualInformation',
    productName,
    amount,
  }),
  [analyticsId.CARD_MODIFY_CREDIT_LIMIT_STEP_3_VIEW]: ({ productName, amount }) => ({
    ...commons,
    pageName: 'modifyCreditLimit/step03/confirmation',
    processStep: 'step03',
    processDetail: 'confirmation',
    productName,
    amount,
  }),

  [analyticsId.CARD_MODIFY_CREDIT_LIMIT_WIZARD_FINISH]: ({ pageName }) => ({
    action: 'click',
    format: 'button',
    component: 'lowerNavigation',
    element: 'confirm',
    eventCategory: pageName,
    eventAction: 'lowerNavigation',
    eventLabel: 'confirm',
    data: true,
  }),
  [analyticsId.CARD_MODIFY_CREDIT_LIMIT_NEXT]: ({ pageName }) => ({
    action: 'continue',
    format: 'button',
    component: 'lowerNavigation',
    element: 'next',
    eventCategory: pageName,
    eventAction: 'lowerNavigation',
    eventLabel: 'navigationNextButton',
    data: true,
  }),
  [analyticsId.CARD_MODIFY_CREDIT_LIMIT_CANCEL]: ({ pageName }) => ({
    action: 'cancel',
    format: 'link',
    component: 'lowerNavigation',
    element: 'cancel',
    eventCategory: pageName,
    eventAction: 'lowerNavigation',
    eventLabel: 'navigationCancelLink',
    data: true,
  }),
  [analyticsId.CARD_MODIFY_CREDIT_LIMIT_PREVIOUS]: ({ pageName }) => ({
    action: 'back',
    format: 'button',
    component: 'lowerNavigation',
    element: 'previous',
    eventCategory: pageName,
    eventAction: 'lowerNavigation',
    eventLabel: 'previous',
    data: true,
  }),
};

export const getCustomTags = variables => ({
  clickSlider: {
    action: 'click',
    format: 'slider',
    component: 'creditLimit',
    element: 'amount',
    eventCategory: variables.pageName,
    eventAction: 'amountSlider',
    eventLabel: 'selection',
  },
  clickDropdown: {
    action: variables.status,
    format: 'dropdown',
    component: 'creditLimit',
    element: 'amount',
    eventCategory: variables.pageName,
    eventAction: 'amountDropdown',
    eventLabel: variables.status
  },
  selectAmount: {
    action: 'select',
    format: 'dropdown',
    component: 'creditLimit',
    element: 'amount',
    amount: variables.amount,
    eventCategory: variables.pageName,
    eventAction: 'amountDropdown',
    eventLabel: 'select',
  },
  showMessageNoLimitPreapproved: {
    action: 'open',
    format: 'message',
    component: 'message/warning/noLimitPreapproved',
    element: 'full',
    eventCategory: variables.pageName,
    eventAction: 'warningMessageNoLimitPreapproved',
    eventLabel: 'view',
  },
  viewContract: {
    action: 'open',
    format: 'document',
    component: 'legalContract',
    element: 'full',
    eventCategory: variables.pageName,
    eventAction: 'legalContract',
    eventLabel: 'view',
  },
  onDownloadPdf: {
    action: 'download',
    format: 'button',
    component: 'legalContract',
    element: 'downloadDocument',
    eventCategory: variables.pageName,
    eventAction: 'clickButton',
    eventLabel: 'downloadLegalContractButton',
  },
  onPrintPdf: {
    action: 'print',
    format: 'button',
    component: 'legalContract',
    element: 'printDocument',
    eventCategory: variables.pageName,
    eventAction: 'clickPrint',
    eventLabel: 'printLegalContract',
  },
  onScrollButtonAction: {
    action: 'scroll',
    format: 'button',
    component: 'legalContract',
    element: 'scrollButton',
    eventCategory: variables.pageName,
    eventAction: 'clickButton',
    eventLabel: 'scrollLegalContractButton',
  },
  onClickPdfLink: {
    action: 'click',
    format: 'link',
    component: 'documents',
    element: variables.documentName,
    eventCategory: variables.pageName,
    eventAction: 'clickLink',
    eventLabel: variables.documentName,
  },
  onSMSClick: {
    action: 'type',
    format: 'textBox',
    component: 'OTP/SMS',
    element: 'enterCode',
    eventCategory: variables.pageName,
    eventAction: 'clickTextBox',
    eventLabel: 'enterCodeTextBox',
  },
  onProcessSuccess: {
    pageName: '/modifyCreditLimit/success',
    sectionFamily: 'banking',
    sectionCategory: 'products',
    sectionName: 'cards',
    interactionType: 'funnel',
    serviceType: 'productSettings',
    processType: 'modifyCreditLimit',
    processStep: 'success',
    productName: variables.productType,
    amount: variables.creditLimit,
  },
  onClickButtonSuccessScreen: {
    action: 'click',
    format: 'link',
    component: 'lowerNavigation',
    element: 'returnToCards',
    eventCategory: '/modifyCreditLimit/success',
    eventAction: 'lowerNavigation',
    eventLabel: 'returnToCards',
  },
  onErrorScreen: {
    pageName: '/modifyCreditLimit/error/',
    sectionFamily: 'banking',
    sectionCategory: 'products',
    sectionName: 'cards',
    interactionType: 'funnel',
    serviceType: 'productSettings',
    processType: 'modifyCreditLimit',
    processStep: 'error',
    processDetail: 'somethingWentWrong',
    errorCategory: 'somethingWentWrong',
    errorDescription: variables.errorDescription,
    productName: variables.productType,
    amount: variables.creditLimit,
  },
  onClickButtonErrorScreen: {
    action: 'click',
    format: 'link',
    component: 'lowerNavigation',
    element: 'returnToCards',
    eventCategory: '/modifyCreditLimit/error/',
    eventAction: 'lowerNavigation',
    eventLabel: 'returnToCards',
  },
});
